export type DrawerTab = 'editor' | 'tree' | 'add' | 'settings';

export interface VisualEditorDrawerCallbacks {
  onOpen?: () => void;
  onClose: () => void;
  onWidgetUpdated: (
    widgetId: string,
    data: Record<string, unknown>,
    parentWidgetContentItemId?: string | null
  ) => Promise<void>;
  onWidgetReordered: (
    widgetIds: string[],
    parentWidgetContentItemId?: string | null
  ) => Promise<void>;
  onWidgetAdded: (
    type: string,
    parentWidgetContentItemId?: string | null,
    insertIndex?: number
  ) => Promise<void>;
  onWidgetDeleted: (widgetId: string, parentWidgetContentItemId?: string | null) => Promise<void>;
  onPageSettingsUpdated: (settings: {
    displayText: string;
    pageTitle: string;
    metaDescription: string;
    path: string;
  }) => Promise<void>;
  onPublish: () => Promise<void>;
  onSaveDraft: () => Promise<void>;
}

export const CONTAINER_CHILD_TYPES: Record<
  string,
  { childType: string; label: string; icon: string }
> = {
  Nav: { childType: 'LinkMenuItem', label: 'Link', icon: '☍' },
  Navbar: { childType: 'LinkMenuItem', label: 'Link', icon: '☍' },
  Footer: { childType: 'LinkMenuItem', label: 'Link', icon: '☍' },
  Menu: { childType: 'LinkMenuItem', label: 'Link', icon: '☍' },
  FeatureList: { childType: 'FeatureItem', label: 'Feature Item', icon: '✦' },
  Counter: { childType: 'CounterItem', label: 'Metric', icon: '⧖' },
  Accordion: { childType: 'AccordionItem', label: 'Accordion Item', icon: '☰' },
  FaqAccordion: { childType: 'AccordionItem', label: 'Accordion Item', icon: '☰' },
  Carousel: { childType: 'CarouselSlide', label: 'Slide', icon: '▣' },
  Team: { childType: 'TeamMember', label: 'Team Member', icon: '◈' },
  Pricing: { childType: 'PricingPlan', label: 'Pricing Plan', icon: '§' },
  Gallery: { childType: 'GalleryItem', label: 'Gallery Item', icon: '▦' },
  TestimonialCarousel: { childType: 'TestimonialItem', label: 'Testimonial', icon: '❝' },
  LogoGrid: { childType: 'LogoItem', label: 'Logo', icon: '❖' },
  Tabs: { childType: 'TabItem', label: 'Tab', icon: '▤' },
  Careers: { childType: 'JobPostingItem', label: 'Job Opening', icon: '💼' },
  FeaturedPosts: { childType: 'PostCard', label: 'Post Card', icon: '📰' },
  Capabilities: { childType: 'CardItem', label: 'Capability Card', icon: '⚡' },
  Fleet: { childType: 'CardItem', label: 'Vessel / Fleet Card', icon: '🚢' },
  Routes: { childType: 'CardItem', label: 'Route / Corridor Card', icon: '✈' },
  QualityAssurance: { childType: 'CardItem', label: 'QA Metric / Zone', icon: '🛡' },
  PromoBanner: { childType: 'ChecklistItem', label: 'Checklist Item', icon: '✓' },
  Services: { childType: 'CardItem', label: 'Service Card', icon: '⚓' },
  Subsidiary: { childType: 'CardItem', label: 'Subsidiary Card', icon: '🏢' },
  Compliance: { childType: 'CardItem', label: 'Compliance Accreditation', icon: '🛡' },
  About: { childType: 'CardItem', label: 'Value Card / Highlight', icon: '✦' },
};

export function isLegacyFlatRepeatingField(key: string): boolean {
  return /^(Card\d|Service\d|AirFreight|SeaFreight|Warehouse|Customs|Zone\d|Lane\d|Vessel\d|Step\d|Category\d|Feature\d|Item\d|Slide\d|Member\d|Plan\d)/i.test(
    key
  );
}

export function escapeHtml(str: string): string {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}
